<template>
  <div class="wlx-signUp-receipt-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt>
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">报名回执表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="signUp-receipt-content">
      <h2 class="signUp-table-title-h2">{{meetDetailTitle}}</h2>
      <el-form :model="signForm" :rules="rules" ref="signForm">
        <table class="sign-table-1" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td colspan="2" class="sign-table-label" width="120px">
              <span class="sp-must-tip">*</span> 申请人姓名
            </td>
             <td colspan="2">
               <el-input v-model="signForm.hostName" disabled></el-input>
            </td>
             <td colspan="2" class="sign-table-label" width="120px">
               <span class="sp-must-tip">*</span> 申请人手机号
            </td>
             <td colspan="2">
                <el-input v-model="signForm.hostPhoneNum" disabled></el-input>
            </td>
             <td colspan="2" class="sign-table-label" width="120px">
              <span class="sp-must-tip"></span> 付款方式
            </td>
            <td colspan="2">
                <el-select v-model="signForm.payWay" placeholder="请选择付款方式" clearable>
                  <el-option label="公对公汇款" :value="1">
                  </el-option>
                   <el-option label="现场刷卡" :value="2">
                  </el-option>
                   <el-option label="微信支付（线上培训）" :value="3">
                  </el-option>
                </el-select>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="sign-table-label">
               <span class="sp-must-tip">*</span>入住酒店
            </td>
            <td  colspan="6">
              <el-select v-model="signForm.hotel" placeholder="请选择入住酒店" clearable style="width:100%;">
                <!-- <el-option label="圣爵菲斯酒店460元/晚（含早）" value="圣爵菲斯酒店460元/晚（含早）"></el-option>
                <el-option label="富力万达嘉华酒店450元/天/间（含早）" value="富力万达嘉华酒店450元/天/间（含早）"></el-option>
                <el-option label="明诚国际酒店420元/晚（含早）" value="明诚国际酒店420元/晚（含早）"></el-option>
                <el-option label="圣爵菲斯之家300元/晚（含早）" value="圣爵菲斯之家300元/晚（含早）"></el-option> -->
                <el-option v-for="(item,index) in hotels" :key="index" :label="item.label" :value="item.label"></el-option>
                <el-option label="自行安排" value="自行安排"></el-option>
              </el-select>
            </td>
            <td colspan="2" class="sign-table-label">
               <span class="sp-must-tip">*</span>到达时间
            </td>
            <td  colspan="2">
              <el-date-picker
                v-model="signForm.ArriveDate"
                type="datetime"
                placeholder="选择到达时间">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="sign-table-label" width="120px">
              <span class="sp-must-tip">*</span> 单位名称
            </td>
            <td colspan="10">
              <el-form-item prop="unitName">
                <el-input v-model="signForm.unitName" autofocus></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="sign-table-label">
              <span class="sp-must-tip">*</span>地址</td>
            <td colspan="4">
              <el-input v-model="signForm.address"></el-input>
            </td>
            <td colspan="2" class="sign-table-label">
              <span class="sp-must-tip">*</span>邮编
            </td>
            <td colspan="4">
              <el-input v-model="signForm.zipCode"></el-input>
            </td>
          </tr>
          <tr>
            <td  colspan="12" class="sign-table-label">
              开票信息(本次会议的参会费一律开增值税普票)
            </td>
          </tr>
          <tr>
            <td colspan="2" class="sign-table-label">
              <span class="sp-must-tip">*</span> 发票抬头
            </td>
            <td colspan="4">
              <el-form-item prop="invoice">
                <el-input v-model="signForm.invoice"></el-input>
              </el-form-item>
            </td>
            <td colspan="2" class="sign-table-label">
              <span class="sp-must-tip">*</span> 纳税人识别号
            </td>
            <td colspan="4">
              <el-form-item prop="taxesNum">
                <el-input v-model="signForm.taxesNum"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="sign-table-label">
              <span class="sp-must-tip">*</span> 开票项目选择
            </td>
            <td colspan="10">
                <div class="sign-up-check-con">
                   <el-checkbox-group v-model="checkList"> 
                      <el-checkbox label="会议费"></el-checkbox>
                      <el-checkbox label="会务费"></el-checkbox>
                      <el-checkbox label="培训费"></el-checkbox>
                    </el-checkbox-group>
                </div>
            </td>
          </tr>
           <tr>       
            <td colspan="2" class="sign-table-label" width="120px">
              备注
            </td>
            <td colspan="10">
              <el-form-item prop="remarks">
                <el-input type="textarea" v-model="signForm.remarks"></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
      <el-table class="sign-table-1" :data="tableData">
        <el-table-column prop="name" label="姓名" width="120px" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.name" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别" align="center" width="104px">
          <template slot-scope="scope">
             <el-select v-model="scope.row.sex" placeholder="" clearable>
                <el-option key="男" label="男" value="男"></el-option>
                <el-option key="女" label="女" value="女"></el-option>
              </el-select>
            <!-- <el-input v-model="scope.row.sex" size="small"></el-input> -->
          </template>
        </el-table-column>
        <el-table-column prop="post" label="职务" align="center" width="250px">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.post" size="small"></el-input> -->
            <el-select v-model="scope.row.post" placeholder="" clearable>
              <el-option key="校领导" label="校领导" value="校领导"></el-option>
              <el-option key="院系领导" label="院系领导" value="院系领导"></el-option>
              <el-option key="专业负责人" label="专业负责人" value="专业负责人"></el-option>
              <el-option key="其他" label="其他" value="其他"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="IDNum" label="身份证号" align="center" width="159px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.IDNum" size="small"></el-input>
          </template>
        </el-table-column> -->
        <el-table-column prop="phoneNum" label="移动电话" align="center" width="232px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.phoneNum" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="E-mail" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.email" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="living" label="单/合住" align="center" width="120px">
          <template slot-scope="scope">
             <el-select v-model="scope.row.living" placeholder="" clearable>
                <el-option key="单住" label="单住" value="单住"></el-option>
                <el-option key="合住" label="合住" value="合住"></el-option>
              </el-select>
            <!-- <el-input v-model="scope.row.living" size="small"></el-input> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="add-table-tr-btn" @click="addTableTr">
        <i class="wl-icon-tianjia"></i>
        <span>点击添加一行</span>
      </div>
      <div class="p-sign-up-tip">
        <p>参会说明：</p>
        <span v-html="meetDetailExplain"></span>
        <!-- <p>
          1、报到时间：2019年9月20日8:00-22:00 会议时间：9月21-22日
          报到地点：南昌融创万达嘉华酒店大堂报到处
          地址：江西省南昌市红谷滩新区南龙蟠街333号
        </p>
        <p>2、请尽量提前报名并提前汇款，每个酒店房间的数量有限，我们将按到款及报到的前后顺序安排，若未经报名前来参会者，会议不能确保住房接待。</p> -->
      </div>
      <div class="submit-btn">
        <el-button size="small" type="primary" @click="fanhui">返回</el-button>
        <el-button size="small" type="primary" @click="submitTable('signForm')" :disabled="isSubmit">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      signForm: {
        hostName:'',
        hostPhoneNum:'',
        payWay:'',
        hotel:'',
        ArriveDate:"",   // 到达时间
        unitName: "",
        address: "",
        zipCode: "",
        invoice: "",
        taxesNum: "",
        remarks:''
      },
      isSubmit: false,
      rules: {
        unitName: [
          { required: true, message: "请输入活动名称", trigger: "blur" }
        ]
      },
      tableData: [
        {
          name: "",
          sex: "",
          post: "",
          phoneNum: "",
          email: "",
          living: ""
        },
        {
          name: "",
          sex: "",
          post: "",
          phoneNum: "",
          email: "",
          living: ""
        },
        {
          name: "",
          sex: "",
          post: "",
          phoneNum: "",
          email: "",
          living: ""
        }
      ],
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      timer: "",
      meetDetailTitle:'',
      meetDetailExplain:'',
      isInfo: true,
      // 酒店列表
      hotels:[],
      checkList:[]
    };
  },
  props: {
    signUpId: {
      type: String,
      default: ""
    }
  },
  computed: {},
  created() {
    // this.getMeetDetail();
    this.getEnrollInfo();
  },
  methods: {
    getEnrollInfo() {
      var that= this;
      this.$http
        .post("/api/XOrg/MeetingEnroll/getEnrollInfo", {
          id: this.signUpId
        })
        .then(res => {
          if (res.code > 0) {
            // 酒店列表
            that.hotels = res.hotels;
            this.signForm.hostName = res.info.CreateDisplayName;
            this.signForm.hostPhoneNum = res.info.CreateUserName;
            this.signForm.payWay = res.info.PaymentType==0?"":res.info.PaymentType;
            this.signForm.hotel = res.info.Hotel;
            this.signForm.ArriveDate = res.info.ArriveDate;
            this.signForm.unitName = res.info.CompanyName;
            this.signForm.address = res.info.Address;
            this.signForm.zipCode = res.info.ZipCode;
            this.signForm.invoice = res.info.Invoice;
            this.signForm.remarks = res.info.Note;
            this.signForm.taxesNum = res.info.TaxNumber;
            this.tableData = JSON.parse(res.info.EnterPerson);
            this.meetDetailTitle = res.activityInfo.title;
            this.meetDetailExplain = res.activityInfo.explain;
            this.checkList = JSON.parse(res.info.InvoiceItem);
          }else{
            that.$message.warning(rst.msg);
          }
        });
    },
    addTableTr() {
      this.tableData.push({
        name: "",
        sex: "",
        post: "",
        phoneNum: "",
        email: "",
        living: ""
      });
    },
    fanhui(){
        this.$router.push({
            name:'EnrollManager'
        })
    },
    submitTable(formName) {
      let situation = [];
      var warningmsg = "";
      if(this.signForm.hostName == ''){
        this.$message({
          message: '请输入申请人姓名',
          type: "warning"
        });
        return false;
      }
     if(this.signForm.hostPhoneNum == ''){
        this.$message({
          message: '请输入申请人号码',
          type: "warning"
        });
        return false;
      }
       if(this.signForm.hotel == ''){
        this.$message({
          message: '请选择入住的酒店',
          type: "warning"
        });
        return false;
      }
      if (this.signForm.ArriveDate == "" || this.signForm.ArriveDate == null) {
        this.$message({
          message: "请选择到达时间",
          type: "warning"
        });
        return false;
      }
     if(this.signForm.address == ''){
        this.$message({
          message: '请输入地址',
          type: "warning"
        });
        return false;
      }
      if (this.signForm.zipCode == "") {
        this.$message({
          message: "请输入邮编",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.invoice == "") {
        this.$message({
          message: "请输入发票抬头",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.taxesNum == "") {
        this.$message({
          message: "请输入纳税人识别号",
          type: "warning"
        });
        return false;
      }

      this.tableData.forEach(item => {
        if (item.name !== "") {
          situation.push(item);
          if(item.living == ''){
            warningmsg = "请完善"+item.name+"的单/合住信息";
          }
           if(item.phoneNum == ''){
            warningmsg = "请完善"+item.name+"的移动电话信息";
          }
          if(item.post == ''){
            warningmsg = "请完善"+item.name+"的职务信息";
          }
          // if(item.sex != '' && item.post != '' && item.phoneNum != '' && item.email != '' && item.living != ''){

          // }else{
          //   warningmsg = item.name+"人员信息不完整";
          // }
        }
      });
      if(warningmsg!=""){
         this.$message({
          message: warningmsg,
          type: "warning"
        });
        return false;
      }

      if(situation.length == 0){
        this.$message({
          message: "至少添加一名报名人员",
          type: "warning"
        });
        return false;
      }
      
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isSubmit = true;
          this.$http
            .post("/api/XOrg/MeetingEnroll/editEnroll", {
              id: this.signUpId,
              phone:this.signForm.hostPhoneNum,
              displayName:this.signForm.hostPhoneNum,
              PaymentType:this.signForm.payWay,
              Hotel:this.signForm.hotel,
              ArriveDate: this.signForm.ArriveDate,
              CompanyName: this.signForm.unitName,
              Address: this.signForm.address,
              Note:this.signForm.remarks,
              ZipCode: this.signForm.zipCode,
              Invoice: this.signForm.invoice,
              TaxNumber: this.signForm.taxesNum,
              EnterPerson: JSON.stringify(situation),
              InvoiceItem:JSON.stringify(this.checkList),
              personCount:situation.length
            })
            .then(res => {
              //  this.isSubmit = false;
              if (res.code > 0) {
                // this.isSubmit = true;
                this.$message({
                  message: "修改成功,即将跳转到管理系统！",
                  type: "success"
                });
                this.timer = setInterval(this.goclpp, 3000);
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              }
            });
        } else {
          this.isSubmit = false;
          this.$message({
            message: "请输入单位名称!",
            type: "warning"
          });
          return false;
        }
      });
    },
    getMeetDetail() {
      this.$http
        .post("/api/XOrg/Special/getSpecialInfo", {
          id: this.signUpId
        })
        .then(res => {
          if (res.code > 0) {
            this.meetDetail = res.info;
          }
        });
    },
    goclpp() {
      this.$router.push({
        name: "EnrollManager"
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss">
.wlx-signUp-receipt-wrapper {
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 55px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .signUp-receipt-content {
    margin: -325px auto 0;
    padding-top: 20px;
    width: 1100px;
    min-height: 400px;
    background: #fff;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .signUp-table-title-h2 {
    padding: 10px 0 20px 0;
    text-align: center;
  }
  .sign-up-h2 {
    padding: 30px 0;
    text-align: center;
  }
  table,
  .el-table {
    margin: 0 auto;
    width: 1060px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
  }
  .sp-must-tip {
    color: red;
  }
  .sign-table-label {
    color: #000;
    font-weight: 600;
    font-size: 16px;
  }
  .el-table th {
    padding: 8px 0;
    border-left: 1px solid #999;
    color: #000;
    background: #f0f0f0;
    font-size: 16px;
  }
  .el-table__header {
    border-bottom: none;
  }
  table td {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
    text-align: center;
  }
  .el-textarea__inner,
  .el-input__inner {
    border: none;
    font-size: 16px;
    color: #000;
  }
  .sign-table-1 {
    tr td {
      height: 40px;
    }
  }
  .add-table-tr-btn {
    padding: 15px 0;
    text-align: center;
    color: #2d82ff;
    cursor: pointer;
  }
  .p-sign-up-tip {
    padding: 10px 30px;
    font-size:16px;
    p{
      margin-bottom: 10px;
    }
  }
  .submit-btn {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
